// ABOUTME: Admin email campaign management interface
// ABOUTME: Tabbed interface for monitoring campaigns, scheduled emails, audit logs, and manual enrollment
import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography, Paper, Container } from '@mui/material';
import CampaignListTab from './admin/CampaignListTab';
import ScheduledEmailsTab from './admin/ScheduledEmailsTab';
import EmailAuditLogTab from './admin/EmailAuditLogTab';
import ManualEnrollmentTab from './admin/ManualEnrollmentTab';
import ErrorBoundary from './ErrorBoundary';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function AdminCampaigns() {
  const [tabValue, setTabValue] = useState(0);

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Campaign Management
        </Typography>

        <Paper>
          <Tabs value={tabValue} onChange={(_, v) => setTabValue(v)}>
            <Tab label="Campaigns" />
            <Tab label="Scheduled Emails" />
            <Tab label="Email Audit Log" />
            <Tab label="Manual Enrollment" />
          </Tabs>

          <TabPanel value={tabValue} index={0}>
            <ErrorBoundary>
              <CampaignListTab />
            </ErrorBoundary>
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <ErrorBoundary>
              <ScheduledEmailsTab />
            </ErrorBoundary>
          </TabPanel>
          <TabPanel value={tabValue} index={2}>
            <ErrorBoundary>
              <EmailAuditLogTab />
            </ErrorBoundary>
          </TabPanel>
          <TabPanel value={tabValue} index={3}>
            <ErrorBoundary>
              <ManualEnrollmentTab />
            </ErrorBoundary>
          </TabPanel>
        </Paper>
      </Box>
    </Container>
  );
}
